import customAxios from "./axiosConfig";
import store from '../../store'

const IdealPaymentService = {
    connectMollie: function (data) {
        var api_url = window.Urls['mollieuser-connect-mollie']();
        return customAxios.post(api_url,data);
    },
    list: function (params){
        var api_url = window.Urls['mollieuser-list']();
        return customAxios.get(api_url, { params: params });
    },
    profile: function () {
        var api_url = window.Urls['mollieuser-profile'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    allProfiles: function () {
        var api_url = window.Urls['mollieuser-all-profiles'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    updateProfile: function (data) {
        var api_url = window.Urls['mollieuser-update-profile'](store.getters['main/getCompanyId']);
        return customAxios.post(api_url,data);
    },
    getOnboardingStatus: function () {
        var api_url = window.Urls['mollieuser-onboarding-status'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    getPaymentList: function () {
        var api_url = window.Urls['mollieuser-payment-list'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    createPayment: function (data) {
        var api_url = window.Urls['mollieuser-create-payment'](store.getters['main/getCompanyId']);
        return customAxios.post(api_url,data);
    },
    disconnect: function () {
        var api_url = window.Urls['mollieuser-disconnect'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    getConnectionStatus: function () {
        var api_url = window.Urls['mollieuser-connection-status'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    rootlineRequestConnection: function (data) {
        var api_url = window.Urls['rootlineuser_start_connection']();
        return customAxios.post(api_url, data);
    },
    getRootlineConnectionStatus: function () {
        var api_url = window.Urls['rootlineuser-connection-status'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    getPaymentsLeft: function () {
        var api_url = window.Urls['mollieuser-payments-left'](store.getters['main/getCompanyId']);
        return customAxios.get(api_url);
    },
    generateMolliePayment(uuid) {
        let api_url = window.Urls['idealpayment-generate-mollie-payment'](uuid)
        return customAxios.get(api_url)
    },
    mollieCheckoutUrl(uuid) {
        let api_url = window.Urls['idealpayment-mollie-checkout-url'](uuid)
        return customAxios.get(api_url)
    },
    gekkoPaymentComplete(uuid) {
        let api_url = window.Urls['idealpayment-gekko-payment-complete'](uuid)
        return customAxios.get(api_url)
    },
    generateRootlinePayment(uuid) {
        let api_url = window.Urls['idealpayment-generate-rootline-payment'](uuid)
        return customAxios.get(api_url)
    },
    regenerateRootlinePayment(uuid) {
        let api_url = window.Urls['idealpayment-regenerate-rootline-payment'](uuid)
        return customAxios.get(api_url)
    },
    rootlineCheckoutUrl(uuid) {
        let api_url = window.Urls['idealpayment-rootline-checkout-url'](uuid)
        return customAxios.get(api_url)
    },
    getRootlinePaymentComplete(uuid) {
        let api_url = window.Urls['idealpayment-rootline-payment-complete'](uuid)
        return customAxios.get(api_url)
    }
};

export default IdealPaymentService;